module.exports = __webpack_public_path__ + "img/map_pin_icon.c35bf5c5.svg";